import Image from 'next/image'

import { useContactModalStore } from '@/lib/stores/contactModalStore'
import { useIntl } from 'react-intl'
import { LuCircleCheckBig } from 'react-icons/lu'

import { routePaths } from '@/lib/core/constants/routes'

import { StatsBox } from '@/lib/features/Dashboard/components/StatsBox'
import { SummaryCard } from '@/lib/features/Dashboard/components/SummaryCard'
import messages from '@/lib/features/Dashboard/Dashboard.messages'
import { Details, Row, Summary } from '@/lib/features/Dashboard/Dashboard.styles'
import { DashboardStats } from '@/lib/features/Dashboard/api'

import { FeatureTypes } from '@/lib/utils/features'

export type ContactsRowProps = {
  onUpdate?: () => void
  dashboardData: DashboardStats | undefined
  isLoading: boolean
}

export const ContactsRow = ({ onUpdate, dashboardData, isLoading }: ContactsRowProps) => {
  const { formatMessage } = useIntl()

  const { openModal: openContactModal } = useContactModalStore()
  const { contacts } = messages
  return (
    <>
      <Row>
        <Summary>
          <SummaryCard
            callBack={() =>
              openContactModal(() => {
                onUpdate?.()
              })
            }
            color={FeatureTypes.CONTACTS}
            icon={<LuCircleCheckBig size="56" />}
            label={formatMessage(contacts.allContacts)}
          />
        </Summary>
        <Details>
          <StatsBox
            href={routePaths.contacts}
            color={FeatureTypes.CONTACTS}
            counter={dashboardData?.contacts.all ?? 0}
            image={
              <Image
                src="/images/dashboard/contacts/contacts-all.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(contacts.allContacts)}
          />
          <StatsBox
            href={routePaths.contacts + '?filter=outbound'}
            color={FeatureTypes.CONTACTS}
            counter={dashboardData?.contacts.sharedFromMe ?? 0}
            image={
              <Image
                src="/images/dashboard/contacts/contacts-shared.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(contacts.contactsShare)}
          />
          <StatsBox
            href={routePaths.contacts + '?filter=inbound'}
            color={FeatureTypes.CONTACTS}
            counter={dashboardData?.contacts.sharedToMe ?? 0}
            image={
              <Image
                src="/images/dashboard/contacts/contacts-sharing.svg"
                alt="Assets"
                width={180}
                height={100}
              />
            }
            isLoading={isLoading}
            label={formatMessage(contacts.contactsSharing)}
          />
        </Details>
      </Row>
    </>
  )
}
